<template>
  <v-form :value="valid" @input="v => $emit('update:valid', v)" ref="form">
    <v-row align="center" no-gutters>
      <v-autocomplete
        :items="getProducts.filter(x => x.est_intermediaire === true)"
        item-value="id"
        item-text="nom"
        class="no-before"
        filled
        :value="fk_product"
        @change="v => $emit('update:fk_product', v)"
        label="Produit"
        required
        :rules="[v => !!v || 'Veuillez sélectionner un produit']"
      ></v-autocomplete>
    </v-row>
    <v-row align="center" no-gutters>
      <v-autocomplete
        :items="getDayChoices"
        item-value="value"
        item-text="text"
        class="no-before"
        filled
        :value="day"
        @change="v => $emit('update:day', v)"
        label="Journée"
        required
        :rules="[v => v !== null || 'Veuillez sélectionner une journée']"
      ></v-autocomplete>
    </v-row>
    <v-row align="center" no-gutters>
      <j-decimal-input
        :value="quantity"
        @input="v => $emit('update:quantity', v)"
        label="Quantité"
        class="no-before"
        filled
        :disabled="fk_product === null"
        :suffix="getProductUnit"
        required
      >
      </j-decimal-input>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AutomaticPrepSlipFields",
  props: {
    fk_product: {
      required: true
    },
    quantity: {
      type: Number,
      required: true
    },
    day: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(["getProducts", "getDayChoices"]),
    getProductUnit() {
      if (this.fk_product !== null) {
        const p = this.getProducts.find(x => x.id === this.fk_product);
        if (p && p.data) {
          return p.data.unite_mesure_inventory;
        }
      }
      return "";
    }
  },
  methods: {
    reset() {
      this.$refs.form.reset();
      this.$emit("update:day", 0);
      this.$emit("update:fk_product", null);
      this.$emit("update:quantity", 0);
    }
  }
};
</script>

<style></style>
